module.exports = __webpack_public_path__ + "media/images/MR_Mobile_HP_top-2a96aaa5.png";